// extracted by mini-css-extract-plugin
export default {"root":"RiverDataChart_root__wjKws","riverData":"RiverDataChart_riverData__0-6hb"};